module.exports = __webpack_public_path__ + "static/media/reset.7448f895.png";